import { ExternalLink } from '@uikit';

export const gallery = [
  {
    image: '/launchpad/stories/autolayer/auto-layer-dapp.png',
  },
  {
    image: '/launchpad/stories/autolayer/my-portfolio-page.png',
  },
];

export const highlights = [
  {
    id: 'liquid-restaking',
    item: (
      <span className="font-semibold">
        1-Click Liquid Restaking: Restake with any token seamlessly in a single transaction.
        AutoLayer facilitates native restaking across various providers, allowing users to earn ETH
        Staking Yields, EigenLayer Points, Symbiotic Points, LRT Points, and AutoLayer Points with
        just a simple click, starting with any asset, as we route liquidity through DEXes.
      </span>
    ),
  },
  {
    id: 'strategies-and-automations',
    item: (
      <span className="font-semibold">
        LRTfi Strategies and Automations: Effortlessly set up LRTfi automations with AutoLayer,
        choosing from a wide range of on-chain and off-chain conditions. Generate yields like never
        before.
      </span>
    ),
  },
  {
    id: 'safe-and-secure',
    item: (
      <span className="font-semibold">
        Safe and Secure: Experience top-tier safety in DeFi with AutoLayer. Our contracts are
        audited, ensuring robust security by connecting with extensively audited and battle-tested
        protocols. Our commitment to your safety includes constantly open bug bounties. Plus, enjoy
        complete control with all funds securely held.
      </span>
    ),
  },
  {
    id: 'next-gen-analytics',
    item: (
      <span className="font-semibold">
        Next Gen Analytics: AutoLayer is developing its analytics suite to track AVSs and LRTs,
        providing clear insights about slashing events, rehypothecations, possible depegs, and all
        critical information regarding all assets involved.
      </span>
    ),
  },
];

export const investors = [
  {
    image: '/launchpad/stories/autolayer/investors/kucoinlabs.png',
    name: 'Kucoin Labs',
    className: 'px-[15px] max-md:py-5',
    width: 94,
    height: 31,
  },
  {
    name: 'GBV',
    image: '/launchpad/stories/autolayer/investors/gbv.png',
    className: 'px-[10px] py-3',
    width: 105,
    height: 46,
  },
  {
    name: 'Staked.vc',
    image: '/launchpad/stories/autolayer/investors/staked.png',
    className: 'px-[10px] max-md:py-6',
    width: 107,
    height: 20,
  },
  {
    name: 'Morning Star Ventures',
    image: '/launchpad/stories/autolayer/investors/morning-star-ventures.png',
    className: 'px-[5px] max-md:py-[19px]',
    width: 115,
    height: 34,
  },
  {
    name: 'Black Edge Capital',
    image: '/launchpad/stories/autolayer/investors/black-edge.png',
    className: 'px-[5px] max-md:py-5',
    width: 114,
    height: 30,
  },
  {
    name: 'Dewhales',
    image: '/launchpad/stories/autolayer/investors/dewhales.png',
    className: 'px-[6px] max-md:py-6',
    width: 113,
    height: 19,
  },
];

export const partners = [
  {
    image: '/launchpad/stories/autolayer/partners/chain-link.png',
    name: 'Chain Link',
    className: 'p-3',
    width: 112,
    height: 34,
  },
  {
    name: 'Balancer',
    image: '/launchpad/stories/autolayer/partners/balancer.png',
    className: 'p-5',
    width: 103,
    height: 20,
  },
  {
    name: 'Paraswap',
    image: '/launchpad/stories/autolayer/partners/paraswap.png',
    className: 'p-5',
    width: 122,
    height: 23,
  },
  {
    name: 'Kelp',
    image: '/launchpad/stories/autolayer/partners/kelp.png',
    className: 'p-3',
    width: 99,
    height: 37,
  },
  {
    name: 'Renzo',
    image: '/launchpad/stories/autolayer/partners/renzo.png',
    className: 'p-5',
    width: 91,
    height: 22,
  },
  {
    name: 'Inception',
    image: '/launchpad/stories/autolayer/partners/inception.png',
    className: 'p-3',
    width: 150,
    height: 36,
  },
  {
    name: 'Camelot',
    image: '/launchpad/stories/autolayer/partners/camelot.png',
    className: 'p-4',
    width: 140,
    height: 34,
  },
  {
    name: 'Gamma',
    image: '/launchpad/stories/autolayer/partners/gamma.png',
    className: 'p-5',
    width: 120,
    height: 20,
  },

  {
    name: 'Etherfi',
    image: '/launchpad/stories/autolayer/partners/etherfi.png',
    className: 'p-3',
    width: 102,
    height: 36,
  },
  {
    name: 'Puffer',
    image: '/launchpad/stories/autolayer/partners/puffer.png',
    className: 'p-2',
    width: 152,
    height: 49,
  },
  {
    name: 'Swell',
    image: '/launchpad/stories/autolayer/partners/swell.png',
    className: 'p-3',
    width: 120,
    height: 41,
  },
  {
    name: 'Bedrock',
    image: '/launchpad/stories/autolayer/partners/bedrock.png',
    className: 'p-2',
    width: 161,
    height: 43,
  },
  {
    name: 'Stake',
    image: '/launchpad/stories/autolayer/partners/stake.png',
    className: 'p-2',
    width: 61,
    height: 61,
  },
  {
    name: 'Mellow',
    image: '/launchpad/stories/autolayer/partners/mellow.png',
    className: 'p-2',
    width: 126,
    height: 53,
  },
  {
    name: 'Symbiotic',
    image: '/launchpad/stories/autolayer/partners/symbiotic.png',
    className: 'p-4',
    width: 139,
    height: 36,
  },
  {
    name: 'Eigen Layer',
    image: '/launchpad/stories/autolayer/partners/eigen-layer.png',
    className: 'p-2',
    width: 105,
    height: 48,
  },
];

export const subPartners = [
  {
    name: 'Everclear',
    image: '/launchpad/stories/autolayer/partners/everclear.png',
    className: 'p-2',
    width: 156,
    height: 56,
  },
  {
    name: 'Nektar Network',
    image: '/launchpad/stories/autolayer/partners/nektar-network.png',
    className: 'p-4',
    width: 118,
    height: 34,
  },
  {
    name: 'BNB Chain',
    image: '/launchpad/stories/autolayer/partners/bnb-chain.png',
    className: 'p-5',
    width: 163,
    height: 29,
  },
];

export const teamMembers = [
  {
    id: 'javier-blanco-thomas',
    fullName: 'Javier Blanco Thomas',
    about: (
      <ul className="ml-5 list-disc max-sm:text-sm">
        <li>
          <ExternalLink
            className="text-primary-600"
            href="https://linkedin.com/in/javierblancothomas"
          >
            LinkedIn
          </ExternalLink>
        </li>
        <li>Studied Physics and Information Technology at UCM.</li>
        <li>
          Founded Glue Digital in 2010; the company has grown to 35 employees, achieving €2.5M in
          ARR with an impressive 90% year-over-year growth.
        </li>
        <li>Received awards from Laus Awards, German Design Council, and Awwwards.</li>
        <li>
          Speaker at conferences like Websummit, 4YFN, Health2.0, and the University of Santiago de
          Compostela.
        </li>
        <li>Actively engages as a mentor, investor, and advisor to various startups.</li>
      </ul>
    ),
    width: 104,
    height: 104,
    position: 'CEO',
    avatar: '/launchpad/stories/autolayer/team/javier.png',
  },
  {
    id: 'anxo-soto',
    fullName: 'Anxo Soto',
    about: (
      <ul className="ml-5 list-disc max-sm:text-sm">
        <li>
          <ExternalLink className="text-primary-600" href="https://linkedin.com/in/mancontr">
            LinkedIn
          </ExternalLink>
        </li>
        <li>Holds a degree in Computer Engineering from UdC.</li>
        <li>Chief Technology Officer at Glue Digital since 2014.</li>
        <li>Author of Universal Scripts, a popular React framework.</li>
        <li>Contributed to numerous cryptography and security protocols.</li>
        <li>Professor in bootcamps and advisor to various startups.</li>
      </ul>
    ),
    width: 104,
    height: 104,
    position: 'CTO',
    avatar: '/launchpad/stories/autolayer/team/anxo.png',
  },
  {
    id: 'diana-d-reinoso',
    fullName: 'Diana D. Reinoso',
    about: (
      <ul className="ml-5 list-disc max-sm:text-sm">
        <li>
          <ExternalLink className="text-primary-600" href="https://linkedin.com/in/dianareinoso">
            LinkedIn
          </ExternalLink>
        </li>
        <li>
          Graduated with a degree in Advertising from UVIGO and completed a Master’s Degree in 3D
          Art Direction at LSD (Lisbon).
        </li>
        <li>Chief Design Officer at Glue Digital since 2012.</li>
        <li>
          Recognized with awards and nominations in competitions like Laus, German Design Council,
          and Awwwards.
        </li>
        <li>Renowned photographer with exhibitions in Spain, Germany, and Portugal.</li>
      </ul>
    ),
    width: 104,
    height: 104,
    position: 'CDO',
    avatar: '/launchpad/stories/autolayer/team/diana.png',
  },
];
